module.exports = __webpack_public_path__ + "h5/img/frank.8622bdf5.jpg";